import React, { useState, useEffect } from "react";
import { Tab, Button, Message, Loader } from "semantic-ui-react";
import { BasicModal } from "../../../../components/Shared";
import { useAuth } from "../../../../hooks";
import { InstitutionsTable } from "./InstitutionsTable";
import { InstitutionForm } from "../../../../components/Admin/InstitutionCmp/InstitutionForm";
import { PlanesAPI } from "../../../../api";
import { useTranslation } from "react-i18next";
import "./Page_Partner_Institution.scss";

export function Page_Partner_Institution() {
  const { accessToken, user } = useAuth();
  const { t } = useTranslation(["partners", "common"]);

  const [showModal, setShowModal] = useState(false);
  const [noPlansError, setNoPlansError] = useState(false);
  const [reload, setReload] = useState(false);
  const [editingInst, setEditingInst] = useState(null);
  const [plans, setPlans] = useState([]);
  const [loadingPlans, setLoadingPlans] = useState(true);
  const [availablePlans, setAvailablePlans] = useState([]);

  // 1️⃣ Cargar todos los planes
  useEffect(() => {
    (async () => {
      setLoadingPlans(true);
      try {
        const resp = await new PlanesAPI().getPlans(accessToken, {
          page: 1,
          limit: 50,
        });
        setPlans(resp.plans || []);
      } catch (err) {
        console.error("Error cargando planes", err);
      } finally {
        setLoadingPlans(false);
      }
    })();
  }, [accessToken]);

  const onReload = () => setReload((r) => !r);

  // 2️⃣ Alta de institución (solo si hay activaciones disponibles)
  const handleNew = () => {
    const availIds = (user.user.planEducaActivations || [])
      .filter((a) => a.quantity > 0)
      .map((a) => a.plan);
    const filtered = plans.filter((p) => availIds.includes(p._id));
    if (!filtered.length) {
      setNoPlansError(true);
      return;
    }
    setAvailablePlans(filtered);
    setEditingInst(null);
    setNoPlansError(false);
    setShowModal(true);
  };

  // 3️⃣ Editar institución existente
  const handleEdit = (inst) => {
    setEditingInst(inst);
    // Permitimos ver el plan actual
    setAvailablePlans([inst.planEduca]);
    setShowModal(true);
  };

  const panes = [
    {
      menuItem: t("partners:institutionTable.activeTab"),
      render: () => (
        <Tab.Pane attached={false}>
          <InstitutionsTable
            active={true}
            reload={reload}
            onReload={onReload}
            onEdit={handleEdit}
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("partners:institutionTable.inactiveTab"),
      render: () => (
        <Tab.Pane attached={false}>
          <InstitutionsTable
            active={false}
            reload={reload}
            onReload={onReload}
            onEdit={handleEdit}
          />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <div className="register-page">
        <div className="register-page__add">
          {noPlansError && (
            <Message
              error
              className="no-plans-message"
              header={t("partners:institutionTable.noPlansHeader")}
              content={t("partners:institutionTable.noPlansContent")}
            />
          )}
          <Button onClick={handleNew}>
            {t("common:actions.newInstitution")}
          </Button>
        </div>

        <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
      </div>

      <BasicModal
        show={showModal}
        close={() => setShowModal(false)}
        title={
          editingInst
            ? t("partners:institutionTable.editInstitutionTitle")
            : t("partners:institutionTable.newInstitutionTitle")
        }
        size="large"
      >
        {loadingPlans ? (
          <Loader active inline="centered" />
        ) : (
          <InstitutionForm
            user={user}
            onReload={onReload}
            close={() => setShowModal(false)}
            plans={availablePlans}
            institution={editingInst}
          />
        )}
      </BasicModal>
    </>
  );
}
